export default __webpack_public_path__ + "static/media/blue3.f7271797.gif";